import { PlatformUtility } from '../../utils/platform-utility';
import { h, render } from 'preact';

import { getSelectorAttribs } from '../../utils/renderer-utils';

import { hiPhotoSwipeInit } from '../../helpers/listing/photoswipe';
import '../../../scss/bundles/listing';

import { MortgageCalculator } from "../components/properties/mortgage-calculator.component";
import { TransferCostCalculator } from "../components/properties/transfer-cost-calculator.component";
import { SelectorTuple } from '../constants/selectors';
import { VirtualTourButton } from '../components/properties/virtual-tour-button.component';
import { VirtualTourModal } from '../components/properties/virtual-tour-modal.component';
import { PropertiesMap } from '../components/commons/properties-map.component';


export function renderComponents() {
  if (PlatformUtility.isOnClient()) {
    // console.log('Running on client');

    const SELECTORS: SelectorTuple[] = [
      {
        name: 'hi-mortgage-calculator',
        component: MortgageCalculator
      },
      {
        name: 'hi-transfer-cost-calculator',
        component: TransferCostCalculator
      },
      {
        name: 'hi-virtual-tour-button',
        component: VirtualTourButton
      },
      {
        name: 'hi-virtual-tour-modal',
        component: VirtualTourModal
      },
      {
        name: 'hi-properties-map',
        component: PropertiesMap
      }
    ];
    
    SELECTORS.forEach((selector) => {
      let targets = document.querySelectorAll(selector.name);
  
      targets.forEach((member) => {
        //get attributes from pug level
        const attributes = getSelectorAttribs(member.attributes);
  
        //create VDOM of component with attributes
        let componentVDOM = h(selector.component, attributes);
        render(componentVDOM, member);
      });
    });

    hiPhotoSwipeInit();
  }
}